import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApplicantService } from 'app/laas/applicant.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'wl-file-drag-upload',
  templateUrl: './file-drag-upload.component.html',
  styleUrls: ['./file-drag-upload.component.css']
})
export class FileDragUploadComponent implements OnInit {
  // files: FileList;
  loading: boolean;
  files: File[] = [];
  currentIndex:number = 100;
  submitFilesDisabled: boolean;
  // fileStatuses: any = [];
  constructor(private snackbar:MatSnackBar, private applicant: ApplicantService) { }

  ngOnInit() {
  }

  @Output() fileUploaded = new EventEmitter<FormData>();
  @Output() close = new EventEmitter<void>();
  @ViewChild('fileInput') fileInput: ElementRef;
  @Input() applicantId:string;

  onDrop(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer.files) {
      this.handleFiles(event.dataTransfer.files);
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }


  openFileSelector(event: Event): void {
    if ((event.target as HTMLElement).tagName !== 'IMG' && !this.files.length) {
      this.fileInput.nativeElement.click();
    }
  }
  
  handleFiles(files: FileList) {
    this.loading = true;
    this.files = Array.from(files);
    this.files.forEach(file => {
      file['status'] = "Pending";
    });

    const formData = new FormData();  
    this.files.forEach(file => {
      formData.append('files', file, file.name);
    });

    // Emit the FormData to be handled by the parent component or service
    this.fileUploaded.emit(formData);

    setTimeout(() => { this.loading = false }, 2000);
  }

  closeComponent() {
    this.close.emit();
  }

  removeFile(event: Event, index: number): void {
    console.log(event)
    event.preventDefault(); // Prevents default behavior
    if (index > -1 && index < this.files.length) {
      this.files.splice(index, 1);
    }
  }

  uploadFiles() {
    this.loading = true;
  
    if (!this.files.length) {
      this.snackbar.open("No files found", "OK");
      this.loading = false;
      return;
    }
  
    this.files.forEach((file, index) => {
      const formData = new FormData();
      formData.append('file', file, file.name);
  
      this.applicant.uploadFile(formData, this.applicantId).pipe(
        finalize(() => {
          this.loading = false;
        })
      ).subscribe(
        (resp) => {
          console.log(resp);
          // this.fileStatuses[file.name] = "Uploaded";
          // console.log(this.fileStatuses)
          if(resp && resp.status){
            this.files[index]['status'] = "Uploaded";
            console.log.apply(this.files)
          }
        },
        (err) => {
          console.log("Something went wrong");
          this.snackbar.open("File uploading interrupted", "OK");
          // this.fileStatuses[file.name] = "Failed";
        }
      );
    });

    this.submitFilesDisabled = true;
  }
  
  
}
